var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderDeco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "620px",
    height: "400px",
    viewBox: "0 0 620 400",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Corner flourish") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "cornerGlow",
    cx: "100%",
    cy: "0%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#9E0707",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "45%",
    stopColor: "#b76e79",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#b76e79",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "topGlow",
    cx: "74%",
    cy: "0%",
    r: "74%",
    gradientTransform: "scale(1, 0.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fea801",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#b76e79",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#b76e79",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "leafRose",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#dd919c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#a11212"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "leafGold",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffc247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f08c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "leafCrimson",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#c81717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#7C0303"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "leafBlush",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffd782"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#fea801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "petalFade",
    x1: "100%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#9E0707",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#b76e79",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "petalGoldFade",
    x1: "100%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fea801",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#fea801",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "softBlur",
    x: "-25%",
    y: "-25%",
    width: "150%",
    height: "150%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9
  })), /*#__PURE__*/React.createElement("g", {
    id: "leaf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 C12,-18 38,-20 54,0 C38,20 12,18 0,0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,0 C19,-2.5 37,-1.5 50,0",
    fill: "none",
    stroke: "#5c0202",
    strokeOpacity: 0.2,
    strokeWidth: 3,
    strokeLinecap: "round"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 620,
    height: 400,
    fill: "url(#topGlow)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340,-16 C334,24 320,58 292,80 C268,99 240,96 232,78",
    stroke: "#9E0707",
    strokeOpacity: 0.55,
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,-10 C282,12 268,34 240,48 C214,61 188,58 184,44",
    stroke: "#b76e79",
    strokeOpacity: 0.7,
    strokeWidth: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236,-2 C222,14 200,22 176,22 C158,22 146,32 150,44 C153,54 165,56 170,48",
    stroke: "#b76e79",
    strokeOpacity: 0.55,
    strokeWidth: 1.8
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(336,6) rotate(62) scale(0.44)",
    fill: "url(#leafGold)",
    opacity: 0.82
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(328,32) rotate(168) scale(0.5)",
    fill: "url(#leafRose)",
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(313,58) rotate(66) scale(0.4)",
    fill: "url(#leafCrimson)",
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(298,74) rotate(174) scale(0.46)",
    fill: "url(#leafGold)",
    opacity: 0.72
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(274,92) rotate(70) scale(0.34)",
    fill: "url(#leafBlush)",
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(252,90) rotate(186) scale(0.38)",
    fill: "url(#leafRose)",
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(283,6) rotate(66) scale(0.36)",
    fill: "url(#leafRose)",
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(275,26) rotate(170) scale(0.42)",
    fill: "url(#leafGold)",
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(256,42) rotate(72) scale(0.32)",
    fill: "url(#leafCrimson)",
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(224,56) rotate(178) scale(0.38)",
    fill: "url(#leafBlush)",
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(224,12) rotate(150) scale(0.34)",
    fill: "url(#leafGold)",
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(202,19) rotate(196) scale(0.3)",
    fill: "url(#leafRose)",
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(158,28) rotate(202) scale(0.26)",
    fill: "url(#leafCrimson)",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(256,2) rotate(146) scale(0.3)",
    fill: "url(#leafRose)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(312,2) rotate(152) scale(0.34)",
    fill: "url(#leafGold)",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 48,
    r: 2.2,
    fill: "#fea801",
    opacity: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270,
    cy: 54,
    r: 2,
    fill: "#9E0707",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 30,
    r: 1.8,
    fill: "#b76e79",
    opacity: 0.6
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170,-8 C164,20 148,44 122,58 C100,70 78,66 74,52",
    stroke: "#b76e79",
    strokeOpacity: 0.6,
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,-6 C230,20 224,46 208,64 C196,78 180,84 168,80",
    stroke: "#9E0707",
    strokeOpacity: 0.45,
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,-4 C322,14 332,26 348,32",
    stroke: "#9E0707",
    strokeOpacity: 0.4,
    strokeWidth: 1.6
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(166,10) rotate(76) scale(0.36)",
    fill: "url(#leafRose)",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(154,38) rotate(184) scale(0.4)",
    fill: "url(#leafGold)",
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(130,54) rotate(86) scale(0.32)",
    fill: "url(#leafCrimson)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(104,66) rotate(192) scale(0.34)",
    fill: "url(#leafBlush)",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(228,14) rotate(38) scale(0.3)",
    fill: "url(#leafGold)",
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(220,44) rotate(196) scale(0.34)",
    fill: "url(#leafRose)",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(178,78) rotate(204) scale(0.3)",
    fill: "url(#leafCrimson)",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(322,16) rotate(226) scale(0.28)",
    fill: "url(#leafBlush)",
    opacity: 0.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250,-6 C256,20 268,42 288,54 C302,62 316,62 324,56",
    stroke: "#9E0707",
    strokeOpacity: 0.5,
    strokeWidth: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,58 C158,76 172,90 192,96 C208,101 222,95 222,84 C222,74 212,69 205,74 C199,78 201,86 208,87",
    stroke: "#b76e79",
    strokeOpacity: 0.52,
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424,-4 C432,20 446,40 468,52 C486,62 504,58 506,46 C508,35 498,28 490,33 C484,37 486,46 494,47",
    stroke: "#7C0303",
    strokeOpacity: 0.45,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(254,10) rotate(116) scale(0.34)",
    fill: "url(#leafGold)",
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(262,32) rotate(18) scale(0.4)",
    fill: "url(#leafRose)",
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(280,48) rotate(120) scale(0.3)",
    fill: "url(#leafCrimson)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(302,60) rotate(12) scale(0.36)",
    fill: "url(#leafGold)",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(156,74) rotate(126) scale(0.28)",
    fill: "url(#leafRose)",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(172,88) rotate(26) scale(0.32)",
    fill: "url(#leafGold)",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(210,92) rotate(18) scale(0.28)",
    fill: "url(#leafBlush)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(430,12) rotate(112) scale(0.32)",
    fill: "url(#leafRose)",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(440,32) rotate(14) scale(0.38)",
    fill: "url(#leafGold)",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(482,58) rotate(10) scale(0.32)",
    fill: "url(#leafRose)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 57,
    r: 2.2,
    fill: "#fea801",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 208,
    cy: 87,
    r: 2.2,
    fill: "#fea801",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 494,
    cy: 47,
    r: 2.4,
    fill: "#fea801",
    opacity: 0.7
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300,94 C290,106 284,118 284,132",
    stroke: "#b76e79",
    strokeOpacity: 0.48,
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470,98 C484,106 494,116 498,130",
    stroke: "#9E0707",
    strokeOpacity: 0.44,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366,104 C356,116 352,126 354,138",
    stroke: "#fea801",
    strokeOpacity: 0.52,
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(294,102) rotate(220) scale(0.26)",
    fill: "url(#leafRose)",
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(284,120) rotate(120) scale(0.24)",
    fill: "url(#leafGold)",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(476,102) rotate(146) scale(0.28)",
    fill: "url(#leafGold)",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(360,110) rotate(214) scale(0.26)",
    fill: "url(#leafGold)",
    opacity: 0.55
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320,-6 C316,8 310,18 300,26",
    stroke: "#b76e79",
    strokeOpacity: 0.5,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290,48 C286,60 284,70 288,82",
    stroke: "#b76e79",
    strokeOpacity: 0.42,
    strokeWidth: 1.4
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(318,6) rotate(84) scale(0.34)",
    fill: "url(#leafGold)",
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(288,56) rotate(198) scale(0.38)",
    fill: "url(#leafRose)",
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 30,
    r: 2.2,
    fill: "#fea801",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288,
    cy: 84,
    r: 2,
    fill: "#fea801",
    opacity: 0.6
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(96,18) rotate(24) scale(0.3)",
    fill: "url(#leafRose)",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(148,110) rotate(148) scale(0.3)",
    fill: "url(#leafGold)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(220,110) rotate(224) scale(0.28)",
    fill: "url(#leafGold)",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(284,116) rotate(160) scale(0.32)",
    fill: "url(#leafGold)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(344,126) rotate(68) scale(0.3)",
    fill: "url(#leafGold)",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(236,76) rotate(250) scale(0.24)",
    fill: "url(#leafBlush)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(330,74) rotate(30) scale(0.28)",
    fill: "url(#leafBlush)",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(430,122) rotate(210) scale(0.28)",
    fill: "url(#leafRose)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(500,120) rotate(24) scale(0.3)",
    fill: "url(#leafRose)",
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(170,112) rotate(196) scale(0.48)",
    fill: "url(#leafRose)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(410,104) rotate(24) scale(0.5)",
    fill: "url(#leafRose)",
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(560,124) rotate(40) scale(0.44)",
    fill: "url(#leafCrimson)",
    opacity: 0.42
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 58,
    r: 1.8,
    fill: "#fea801",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 306,
    cy: 126,
    r: 2,
    fill: "#b76e79",
    opacity: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 380,
    cy: 118,
    r: 1.6,
    fill: "#9E0707",
    opacity: 0.4
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(200,0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 420,
    height: 340,
    fill: "url(#cornerGlow)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#softBlur)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420,2 C328,26 264,86 234,172 C286,98 348,48 420,32 Z",
    fill: "url(#petalFade)",
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420,56 C358,100 320,154 304,226 C332,160 372,110 420,84 Z",
    fill: "url(#petalFade)",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420,112 C386,156 368,208 368,268 C380,208 400,162 420,136 Z",
    fill: "url(#petalGoldFade)",
    opacity: 0.32
  })), /*#__PURE__*/React.createElement("path", {
    d: "M420,216 A216,216 0 0 1 204,0",
    stroke: "#b76e79",
    strokeOpacity: 0.34,
    strokeWidth: 1.2,
    strokeDasharray: "3 8",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420,132 A132,132 0 0 1 288,0",
    stroke: "#fea801",
    strokeOpacity: 0.28,
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M418,6 C372,34 348,72 328,112 C312,146 288,178 254,196 C226,211 200,206 190,190 C181,176 188,160 202,157 C214,154 224,164 220,176",
    stroke: "#9E0707",
    strokeOpacity: 0.6,
    strokeWidth: 2.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420,86 C396,104 382,132 376,164 C370,198 356,228 330,248 C312,262 292,258 288,244 C285,232 295,224 305,228 C313,231 314,240 309,245",
    stroke: "#7C0303",
    strokeOpacity: 0.5,
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414,0 C380,10 340,16 300,26 C262,36 228,50 210,74 C197,91 200,108 214,111 C226,114 234,104 230,95",
    stroke: "#b76e79",
    strokeOpacity: 0.72,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420,296 C394,292 374,274 372,250 C370,228 386,212 404,214 C418,216 424,228 417,236 C412,242 403,240 402,233",
    stroke: "#b76e79",
    strokeOpacity: 0.5,
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,58 C168,44 190,44 200,56 C209,67 204,80 192,80 C182,80 178,72 182,66",
    stroke: "#fea801",
    strokeOpacity: 0.68,
    strokeWidth: 1.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(360,42) rotate(190) scale(0.58)",
    fill: "url(#leafRose)",
    opacity: 0.82
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(342,76) rotate(104) scale(0.46)",
    fill: "url(#leafGold)",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(330,110) rotate(197) scale(0.64)",
    fill: "url(#leafCrimson)",
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(314,146) rotate(112) scale(0.5)",
    fill: "url(#leafRose)",
    opacity: 0.72
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(292,176) rotate(203) scale(0.56)",
    fill: "url(#leafGold)",
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(262,194) rotate(122) scale(0.42)",
    fill: "url(#leafRose)",
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(398,106) rotate(158) scale(0.52)",
    fill: "url(#leafCrimson)",
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(381,146) rotate(232) scale(0.44)",
    fill: "url(#leafGold)",
    opacity: 0.72
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(374,190) rotate(167) scale(0.6)",
    fill: "url(#leafRose)",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(356,228) rotate(238) scale(0.46)",
    fill: "url(#leafCrimson)",
    opacity: 0.54
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(330,250) rotate(174) scale(0.42)",
    fill: "url(#leafGold)",
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(378,14) rotate(150) scale(0.5)",
    fill: "url(#leafGold)",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(334,24) rotate(214) scale(0.44)",
    fill: "url(#leafRose)",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(286,36) rotate(147) scale(0.58)",
    fill: "url(#leafCrimson)",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(240,56) rotate(211) scale(0.46)",
    fill: "url(#leafRose)",
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(216,86) rotate(139) scale(0.4)",
    fill: "url(#leafGold)",
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(198,64) rotate(246) scale(0.34)",
    fill: "url(#leafGold)",
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(404,60) rotate(178) scale(0.42)",
    fill: "url(#leafBlush)",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(300,140) rotate(186) scale(0.46)",
    fill: "url(#leafCrimson)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(252,80) rotate(160) scale(0.38)",
    fill: "url(#leafBlush)",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(396,286) rotate(206) scale(0.36)",
    fill: "url(#leafRose)",
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(374,258) rotate(258) scale(0.32)",
    fill: "url(#leafGold)",
    opacity: 0.46
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 176,
    r: 3.4,
    fill: "#fea801",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 309,
    cy: 245,
    r: 3.2,
    fill: "#9E0707",
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 95,
    r: 3.2,
    fill: "#fea801",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 352,
    cy: 60,
    r: 2.6,
    fill: "#7C0303",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298,
    cy: 90,
    r: 2.2,
    fill: "#b76e79",
    opacity: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 392,
    cy: 214,
    r: 2.6,
    fill: "#fea801",
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 124,
    r: 2,
    fill: "#9E0707",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 182,
    cy: 66,
    r: 2.4,
    fill: "#b76e79",
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404,
    cy: 168,
    r: 2,
    fill: "#7C0303",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402,
    cy: 233,
    r: 2.6,
    fill: "#fea801",
    opacity: 0.55
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M548,54 C556,74 572,88 594,94",
    stroke: "#7C0303",
    strokeOpacity: 0.4,
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498,72 C486,88 482,104 486,120 C489,132 500,138 506,130",
    stroke: "#9E0707",
    strokeOpacity: 0.4,
    strokeWidth: 1.6
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(446,92) rotate(202) scale(0.42)",
    fill: "url(#leafGold)",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(518,110) rotate(214) scale(0.4)",
    fill: "url(#leafCrimson)",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(588,108) rotate(206) scale(0.38)",
    fill: "url(#leafRose)",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(524,64) rotate(196) scale(0.34)",
    fill: "url(#leafGold)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(598,66) rotate(210) scale(0.32)",
    fill: "url(#leafBlush)",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 506,
    cy: 130,
    r: 2.4,
    fill: "#fea801",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 538,
    cy: 100,
    r: 2.2,
    fill: "#fea801",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 612,
    cy: 92,
    r: 2,
    fill: "#b76e79",
    opacity: 0.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M430,30 C446,52 456,76 452,100 C448,120 432,128 424,118 C417,109 425,98 434,103",
    stroke: "#9E0707",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520,50 C534,68 548,84 570,92 C588,98 604,92 604,80 C604,70 594,64 587,70",
    stroke: "#7C0303",
    strokeOpacity: 0.45,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(436,44) rotate(30) scale(0.4)",
    fill: "url(#leafGold)",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(450,68) rotate(140) scale(0.44)",
    fill: "url(#leafRose)",
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(456,92) rotate(24) scale(0.38)",
    fill: "url(#leafCrimson)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(446,116) rotate(150) scale(0.34)",
    fill: "url(#leafGold)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(528,60) rotate(126) scale(0.36)",
    fill: "url(#leafRose)",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(542,78) rotate(20) scale(0.42)",
    fill: "url(#leafGold)",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(562,90) rotate(130) scale(0.34)",
    fill: "url(#leafCrimson)",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(584,94) rotate(16) scale(0.36)",
    fill: "url(#leafRose)",
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(392,88) rotate(196) scale(0.5)",
    fill: "url(#leafRose)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(500,78) rotate(24) scale(0.46)",
    fill: "url(#leafGold)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(536,116) rotate(186) scale(0.42)",
    fill: "url(#leafCrimson)",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(608,104) rotate(200) scale(0.36)",
    fill: "url(#leafRose)",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 434,
    cy: 103,
    r: 2.4,
    fill: "#fea801",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 587,
    cy: 70,
    r: 2.4,
    fill: "#fea801",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528,
    cy: 86,
    r: 2.2,
    fill: "#9E0707",
    opacity: 0.45
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M618,126 C602,146 594,170 596,196 C598,224 610,248 620,262",
    stroke: "#b76e79",
    strokeOpacity: 0.62,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620,320 C604,316 594,302 596,286 C598,272 610,264 618,270",
    stroke: "#9E0707",
    strokeOpacity: 0.48,
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596,180 C584,192 578,206 580,222",
    stroke: "#9E0707",
    strokeOpacity: 0.4,
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(606,142) rotate(196) scale(0.4)",
    fill: "url(#leafRose)",
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(596,168) rotate(150) scale(0.36)",
    fill: "url(#leafGold)",
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(596,196) rotate(202) scale(0.42)",
    fill: "url(#leafCrimson)",
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(602,224) rotate(146) scale(0.36)",
    fill: "url(#leafGold)",
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(612,248) rotate(200) scale(0.34)",
    fill: "url(#leafRose)",
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(612,312) rotate(196) scale(0.34)",
    fill: "url(#leafRose)",
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(598,296) rotate(140) scale(0.3)",
    fill: "url(#leafGold)",
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(600,276) rotate(210) scale(0.28)",
    fill: "url(#leafBlush)",
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(582,198) rotate(60) scale(0.3)",
    fill: "url(#leafCrimson)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(578,216) rotate(340) scale(0.26)",
    fill: "url(#leafGold)",
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(608,258) rotate(70) scale(0.26)",
    fill: "url(#leafBlush)",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(608,340) rotate(160) scale(0.28)",
    fill: "url(#leafRose)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(586,332) rotate(226) scale(0.24)",
    fill: "url(#leafGold)",
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    href: "#leaf",
    transform: "translate(600,364) rotate(120) scale(0.22)",
    fill: "url(#leafGold)",
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 156,
    r: 2.2,
    fill: "#fea801",
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 606,
    cy: 236,
    r: 2,
    fill: "#fea801",
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 618,
    cy: 270,
    r: 2.2,
    fill: "#fea801",
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580,
    cy: 222,
    r: 1.8,
    fill: "#9E0707",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 592,
    cy: 352,
    r: 1.8,
    fill: "#b76e79",
    opacity: 0.35
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderDeco);
export default __webpack_public_path__ + "static/media/header-deco.09cf70c2a716937cf782402341e8dda3.svg";
export { ForwardRef as ReactComponent };